export const PlayerStatTypes = {
    0: "Goals",
    1: "Assists",
    2: "Shots",
    3: "HockeyHits",
    4: "HockeyBlockedShots",
    5: "SoccerTackleWon",
    6: "SoccerCleanSheet",
    7: "SoccerPassIntercepted",
    8: "BasketballPoints",
    9: "BasketballAssists",
    10: "BasketballRebounds",
    11: "BasketballThreePointers",
    12: "BasketballSteals",
    13: "AustralianFootballKicks",
    14: "AustralianFootbalHandballs",
    15: "AustralianFootballTackles",
    16: "AustralianFootballHitouts",
    17: "AustralianFootballGoals",
    18: "RugbyTries",
    19: "RugbyTryAssists",
    20: "RugbyLineBreaks",
    21: "RugbyTackles",
    22: "RugbyGoals",
    23: "RugbyTackleBreaks",
    24: "CricketRuns",
    25: "CricketFours",
    26: "CricketSixes",
    27: "CricketFiftyRuns",
    28: "CricketWickets",
    29: "CricketThreeWickets",
};
